import { useRoute } from 'vue-router'
import { getLocaleFromPath, addLocaleToPath } from '../i18n/index.js'

export const useLandingRedirect = () => {
  const route = useRoute()
  
  // Get the landing page URL from environment variable
  const getLandingUrl = () => {
    return import.meta.env.VITE_BASE_LANDING_URL
  }
  
  // Get current locale from the route path
  const getCurrentLocale = () => {
    return getLocaleFromPath(route.path)
  }
  
  // Redirect to landing page with proper language support
  const redirectToLanding = async (path = '/') => {
    const landingUrl = getLandingUrl()
    
    // Build the final URL with locale if needed
    let finalPath = path
    let queryParam = ''
    
    // Only add locale if we're explicitly on a Spanish route (starts with /es/)
    if (route.path.startsWith('/es/')) {
      finalPath = addLocaleToPath(path, 'es')
      queryParam = '?lang=es'
    } else {
      // Force English to override seo-ssr's language memory
      queryParam = '?lang=en'
    }
    
    const redirectUrl = `${landingUrl}${finalPath}${queryParam}`
    
    // External redirect to seo-ssr
    window.location.href = redirectUrl
  }
  
  // Specific methods for common redirects
  const redirectToHome = () => redirectToLanding('/')
  const redirectToFeatures = () => redirectToLanding('/features')
  const redirectToPricing = () => redirectToLanding('/pricing')
  const redirectToBlog = () => redirectToLanding('/blog')
  const redirectToAbout = () => redirectToLanding('/about')
  const redirectToContact = () => redirectToLanding('/contact')
  const redirectToPrivacy = () => redirectToLanding('/privacy')
  const redirectToTerms = () => redirectToLanding('/terms')
  
  return {
    redirectToLanding,
    redirectToHome,
    redirectToFeatures,
    redirectToPricing,
    redirectToBlog,
    redirectToAbout,
    redirectToContact,
    redirectToPrivacy,
    redirectToTerms,
    getCurrentLocale,
    getLandingUrl
  }
} 